import {
  ControlledCheckbox,
  ControlledDatePicker,
  ControlledRadioGroup,
  ControlledTextField,
  ControlledTimePicker
} from 'components/shared/ControlledFields';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'hooks';
import { shouldDisableDateAfterFirstOfMonth } from 'utils/date';

const FormContent = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();
  const { hasTravelMovementsFeature } = useSelector(({ grants }) => grants);

  return (
    <Grid width="500px" container direction={'column'} spacing={2.5} pb={3.75}>
      <Grid pt={0} ml={2.5}>
        <ControlledCheckbox
          control={control}
          name={'active'}
          label={t('travelCost.enableTravelCost')}
        />
      </Grid>
      <Grid ml={4} mt={3}>
        <ControlledRadioGroup
          direction="row"
          options={[
            {
              value: 'shortest',
              label: t('travelCost.distanceTypeShortest')
            },
            {
              value: 'fastest',
              label: t('travelCost.distanceTypeFastest')
            }
          ]}
          control={control}
          name="distance_type"
          label={t('travelCost.distanceType')}
        />
      </Grid>
      <Grid item mt={1}>
        <ControlledTimePicker
          fullWidth
          control={control}
          label={t('travelCost.travelExpMaxInterval')}
          name="travel_exp_max_interval"
        />
      </Grid>
      {hasTravelMovementsFeature && (
        <>
          <Grid item>
            <ControlledCheckbox
              control={control}
              label={t('travelCost.includeBusinessTravelMovements')}
              name="include_business_travel_movements"
            />
          </Grid>
          <Grid item>
            <ControlledDatePicker
              control={control}
              name="travel_movements_activation_date"
              label={t('travelCost.travelMovementActivationDate')}
              fullWidth={true}
              shouldDisableDate={shouldDisableDateAfterFirstOfMonth}
              defaultValue=""
            />
          </Grid>
        </>
      )}
      <Grid item>
        <ControlledCheckbox
          control={control}
          label={t('travelCost.retrieveDistanceService')}
          name="use_distance_webservice"
        />
      </Grid>
      <Grid item>
        <ControlledTextField
          control={control}
          label={t('travelCost.username')}
          name="username"
        />
      </Grid>
      <Grid item>
        <ControlledTextField
          type="password"
          control={control}
          label={t('travelCost.password')}
          name="password"
        />
      </Grid>
    </Grid>
  );
};

export default FormContent;
